import { registerDecorator } from 'class-validator';
import { GeoPoint } from '../../../model/location/geopoint';

export const IsGeoPoint = () => (object: Object, propertyName: string) => {
  registerDecorator({
    name: 'GeoPoint',
    propertyName,
    target: object.constructor,
    validator: {
      validate: (value) => {
        try {
          GeoPoint.fromDTO(value);
        } catch (_) {
          return false;
        }
        return true;
      },
      defaultMessage: () => 'GeoPoint must be a valid GeoPoint object',
    },
  });
};
